import script from "./ProjectOrders.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectOrders.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectOrders.vue?vue&type=style&index=0&id=2174315f&scoped=true&lang=css"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2174315f"]])

export default __exports__